/* eslint-disable @typescript-eslint/dot-notation */
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { UtilityService } from 'src/app/core/services/utility.service';
import { RouterState } from 'src/app/features/auth/redux/router-state';
import { MODE } from 'src/app/shared/constants/general-constants';
import { SpinnerState } from 'src/app/shared/ui/spinner/redux/spinner.state';
import { drbMetadata } from 'src/app/shared/utils/drb-metadata';
import { ENVIRONMENT } from 'src/environments/environment';
import { DrbState, LoadDrbByVersion, LoadDrbVersions } from '../redux';
import { NgIf, NgFor } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { NbCardModule, NbButtonModule, NbIconModule, NbRouteTabsetModule } from '@nebular/theme';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-view-drb',
    templateUrl: '../drb-sources/drb-sources.component.html',
    styleUrls: ['../drb-sources/drb-sources.component.css'],
    imports: [NgIf, SharedModule, NbCardModule, NgSelectComponent, FormsModule, NgFor, NgOptionComponent, NbButtonModule, NbIconModule, NbRouteTabsetModule]
})
export class ViewDrbComponent implements OnInit, OnDestroy {
  public viewDrb$: Observable<any[]> = inject(Store).select(DrbState.view_drb);
  public version$: Observable<any[]> = inject(Store).select(DrbState.versions);
  public loading$: Observable<boolean> = inject(Store).select(SpinnerState.isLoading);
  public username$: Observable<string> = inject(Store).select(RouterState.username);
  private unsubscribe: Subject<void> = new Subject();

  public spin;
  public displayVersionButton;
  public mode;
  public metaData;
  public username;
  public versions: any[];
  public versionSelected;
  public deployInProgres = false;
  public environment: string = ENVIRONMENT.name;
  public bundle_name: string;
  public draftVersion;

  public sourceTabs: any[] = [
    {
      title: $localize`Strings`,
      route: './strings'
    },
    {
      title: $localize`Files`,
      route: './files'
    },
    {
      title: $localize`Images`,
      route: './images'
    },
    {
      title: $localize`Links`,
      route: './links'
    },
    {
      title: $localize`Videos`,
      route: './videos'
    }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    public utility: UtilityService
  ) {}

  public ngOnInit() {
    this.route.url.subscribe((event) => {
      this.bundle_name = event[1].path;
      this.store.dispatch(new LoadDrbVersions(this.bundle_name));
    });
    this.mode = MODE.VIEW;
    this.displayVersionButton = true;
    this.loadDrbData();
    this.version$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data.length > 0) {
        this.versions = [...data].reverse();
        this.draftVersion = this.versions[0];
      }
    });
    this.loading$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.spin = data));
    this.username$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.username = data));
    this.viewDrb$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data) {
        this.metaData = drbMetadata(data);
        this.versionSelected = true;
        if (this.router.url.includes('drb/' + this.bundle_name + '/view')) {
          this.router.navigate(['/drb/' + this.bundle_name + '/view/strings']);
        }
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public manageContributors() {}

  public onChange(version) {
    if (version) {
      this.store.dispatch(new LoadDrbByVersion(version, this.bundle_name));
    }
  }

  public loadDrbData() {
    this.viewDrb$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      this.metaData = drbMetadata(data);
    });
  }
  public reload() {}

  public displayContributors() {
    if (this.metaData['contributors']) {
      const contributors = JSON.parse(JSON.stringify(this.metaData['contributors'])).filter(
        (element) => element.length > 0
      );

      return contributors.join(', ');
    }
  }
}
